import appRouter from '../../../services/AppRouter/AppRouter';

const getPageLink = ({ pageType, pageId }) => {
  // Build page link
  switch (pageType) {
    case 'HUB':
      return `/cms/hub/${pageId.toString()}`;
    default:
      return `/cms/page/${pageId.toString()}`;
  }
};

export const cmsPageRedirect = params => {
  appRouter.goTo(getPageLink(params));
};

export const cmsPageTo = params => {
  return getPageLink(params);
};
